<template>
  <HomeHeader />
  <HomeBody />
</template>

<script>
import HomeHeader from '../molecules/HomeHeader.vue'
import HomeBody from '../molecules/HomeBody.vue'

export default {
  name: 'HomeView',
  components: {
    HomeHeader,
    HomeBody,
  }
}
</script>
